"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Sharing = void 0;
var helpers_1 = require("../helpers/");
var utilities_1 = require("../utilities");
var SHARE_LABELS = {
    facebook: 'Facebook',
    twitter: 'Twitter',
    email: 'Email',
    linkedin: 'LinkedIn',
    pinterest: 'Pinterest',
    link: 'Link',
};
var Sharing = (function () {
    function Sharing(apiSharing, referrers, shareLink) {
        var _this = this;
        this.link = '';
        this.name = apiSharing === null || apiSharing === void 0 ? void 0 : apiSharing.name;
        this.slug = apiSharing === null || apiSharing === void 0 ? void 0 : apiSharing.slug;
        this.targets = (apiSharing === null || apiSharing === void 0 ? void 0 : apiSharing.targets) ? apiSharing.targets : [];
        if (shareLink && (0, helpers_1.isURL)(shareLink)) {
            var host = new URL(shareLink).host;
            this.link = (referrers === null || referrers === void 0 ? void 0 : referrers.includes(host)) ? shareLink : '';
        }
        this.sites = __spreadArray(__spreadArray([], this.targets.map(function (target) { return ({
            icon: "https://embed.kijk.nl/images/".concat(target, ".svg"),
            label: SHARE_LABELS[target],
            src: function () {
                (0, utilities_1.trackShareLink)(target);
                var _a = jwplayer().getPlaylistItem(), title = _a.title, kijkLink = _a.kijkLink;
                var link = _this.link || encodeURIComponent(kijkLink);
                window.open((0, utilities_1.getTargetUrl)(target, link, title));
            },
        }); }), true), [
            {
                icon: 'https://embed.kijk.nl/images/link.svg',
                label: 'Link',
                src: function () {
                    (0, utilities_1.trackShareLink)('link');
                    var kijkLink = jwplayer().getPlaylistItem().kijkLink;
                    var link = _this.link || kijkLink;
                    (0, utilities_1.copyToClipboard)(link);
                    (0, utilities_1.addToolTip)();
                },
            },
        ], false);
    }
    return Sharing;
}());
exports.Sharing = Sharing;
